import PropTypes from 'prop-types';
// Utils
import { cn } from 'utils';
// Styles
import style from './OptionButton.module.css';
// Components
import { Picto, availablePictos } from '../Picto/Picto';

function OptionButton({
  onClick, icon, iconPosition, color, disabled, active, className, children,
}) {
  return (
    <button
      type="button"
      className={cn([
        style.optionButton,
        style[iconPosition],
        style[color],
        active && style.active,
        className,
        'ui-option-button',
      ])}
      onClick={onClick}
      disabled={disabled}
    >
      {icon ? <Picto icon={icon} className={cn([style.icon, 'ui-option-button__icon'])} /> : null}
      {children}
    </button>
  );
}

OptionButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onClick: PropTypes.func,
  icon: PropTypes.oneOf(Object.keys(availablePictos)),
  iconPosition: PropTypes.oneOf(['left', 'right']),
  color: PropTypes.oneOf(['black', 'white']),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
};

OptionButton.defaultProps = {
  onClick: () => {},
  icon: null,
  iconPosition: 'left',
  color: 'black',
  className: null,
  disabled: false,
  active: false,
};

export default OptionButton;
